import React from 'react'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link, NavLink } from 'react-router-dom';

function Topnav() {
  return (
    <Navbar fixed="top" collapseOnSelect expand="lg" className="bg-body-tertiary mb-5 navbar_bg">
      <Container fluid>
        <Navbar.Brand className='brand' as={Link} to="/"><img className='logo' src='/images/logo/logo.jpg' /></Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            <NavLink className="topnav_navlink link_text" to="/">Home</NavLink>
            <NavLink className="topnav_navlink link_text" to="/feature">Features</NavLink>
            <NavLink className="topnav_navlink link_text" to="/pricing">Pricing</NavLink>
          </Nav>
          <Nav>
            <NavLink className="topnav_navlink link_text" to="/login">Login</NavLink>
            <NavLink className="topnav_navlink link_text" to="/signup">SignUp</NavLink>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}

export default Topnav